module.exports = __webpack_public_path__ + "media/custom/images/img18-06a339b45727bbfb9463a168d2fe4cd9.png";